import "../styles/Navbar.css";
import { Link } from "react-router-dom";

const Navbar = ({ logo }) => {
  return (
    <div className="navbar">
      <div className="navbar_wrapper">
        <div className="logo">
          <Link to="/">{logo}</Link>
        </div>
        <ul className="nav_link">
          <li className="link">
            <Link to="/">Home</Link>
          </li>
          <li className="link">
            <Link to="/about">About</Link>
          </li>
          <li className="link">
            <Link to="/projects">Projects</Link>
          </li>
          <li>
            <Link to="/contact">
              <button>Get in touch</button>
            </Link>
          </li>
        </ul>
      </div>
      <div className="line"></div>
    </div>
  );
};

export default Navbar;
